import api from './constants';

export interface LoginResponse {
  token: string;
  user: {
    id: string;
    email: string;
    role: string;
    name?: string;
  };
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export const authApi = {
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    try {
      const response = await api.post<LoginResponse>('/auth/login', credentials);
      return response.data;
    } catch (error: any) {
      // Chuyển tiếp lỗi để component xử lý
      throw error;
    }
  },

  // Get current user profile
  getCurrentUser: async (): Promise<LoginResponse['user']> => {
    try {
      const response = await api.get<{ user: LoginResponse['user'] }>('/auth/profile');
      return response.data.user;
    } catch (error: any) {
      // This will be handled by the global interceptor in config.ts
      throw error;
    }
  },

  // Logout 
  logout: async (): Promise<void> => {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      // Even if logout fails on server, still clear local storage
      console.error('Logout error:', error);
    } finally {
      // Clear local storage regardless of server response
      localStorage.removeItem('auth_token');
      sessionStorage.removeItem('auth_token');
      localStorage.removeItem('user');
    }
  }
}; 